import i18n from '../i18n';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const ANONYMOUS_ID_KEY = 'calmpi_anonymous_id';
const createAnonymousId = () => window.crypto?.randomUUID?.() ||
  `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
const getAnonymousId = () => {
  let id = localStorage.getItem(ANONYMOUS_ID_KEY);
  if (!id) {
    id = createAnonymousId();
    localStorage.setItem(ANONYMOUS_ID_KEY, id);
  }
  return id;
};
const LANGUAGE_TAGS = {
  he: 'he-IL',
  en: 'en-US',
  es: 'es-ES',
};

const request = async (path, options = {}) => {
  const language = i18n.resolvedLanguage || i18n.language || 'en';
  const headers = {
    'Content-Type': 'application/json',
    'x-platform': 'web',
    'x-app-name': 'calmpi-website',
    'x-app-version': '0.1.0',
    'x-language': language,
    'x-language-tag': LANGUAGE_TAGS[language] || 'en-US',
    'x-anonymous-id': getAnonymousId(),
  };
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: { ...headers, ...(options.headers || {}) },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok || body.id === -1) {
    throw new Error(body.message || body.error?.message || 'הבקשה נכשלה');
  }
  return body.data ?? body;
};

export const getPolygonPlaces = ({ latitude, longitude, radius = 5000 }) =>
  request(`/search/places/with-footprints?${new URLSearchParams({
    latitude,
    longitude,
    radius,
  })}`);

export const searchPlaces = ({ query, latitude, longitude }) =>
  request('/search/places', {
    method: 'POST',
    body: JSON.stringify({
      query,
      latitude,
      longitude,
      radius: 5000,
      setInHistory: false,
    }),
  });

export const getPlace = (id) => request(`/search/places/${id}`);

export const getContainedPlaces = (id) => request(`/search/places/${id}/children`);

export const setPlacePopularityVote = (id, vote) =>
  request(`/search/places/${id}/popularity-vote`, {
    method: 'PUT',
    body: JSON.stringify({ vote }),
  });

export const getPlaceCategories = () => request('/places/categories');

export const submitNewPlace = (payload) =>
  request('/places', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
export const submitPlaceEdit = (payload) =>
  request('/place-edit-submissions', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const createPlaceContinuationDraft = (payload) =>
  request('/place-continuation-drafts', { method: 'POST', body: JSON.stringify(payload) });
export const openPlaceContinuationDraft = (token) =>
  request(`/place-continuation-drafts/${encodeURIComponent(token)}`);
export const getPlaceContinuationDraftStatus = (token) =>
  request(`/place-continuation-drafts/${encodeURIComponent(token)}/status`);
